import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class AdminPositionEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "AdminPosition";
        this.primaryEnterpriseComponent = "AdminPosition";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "AdminPosition";
        eom.enterpriseComponent = "AdminPosition";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "AdminPositionEmployee";
        eom.enterpriseComponent = "AdminPositionEmployee";
        eom.relationship = "AdminPositionAdminPositionEmployee";
        this.enterpriseComponentMembers.set(eom.name, eom);

    }
}

export default AdminPositionEnterpriseObjectMetadata;